import React, { createRef, ReactNode, useEffect, useState } from "react";

import "./notification.css";

export function NotificationWrapper() {
    const notificationWrapper = createRef<HTMLDivElement>();

    const [currentNotification, setCurrentNotification] = useState<ReactNode>(<></>);
    const [pos, setPos] = useState<{ x: number, y: number }>({ x: 0, y: 0 });
        useEffect(() => {
            window.addEventListener("openNotification", handleEvent);
            return () => {
                window.removeEventListener("openNotification", handleEvent);
            }
        })
    
    
        function handleEvent(e: CustomEventInit<{ el: ReactNode, pos: { x: number, y: number } }>) {
            setCurrentNotification((e.detail as any)?.el ?? <></>);
            setPos((e.detail as any)?.pos ?? { x: 0, y: 0 });
        }

        function checkClick(event: Event) {
            if(!notificationWrapper.current?.contains( event.target as Node ) ){
                closeNotification();
            }
        }
    
        useEffect(() => {
            window.addEventListener("click", checkClick);
            window.addEventListener("scroll", closeNotification);
            return () => {
                window.removeEventListener("click", checkClick);
                window.removeEventListener("scroll", closeNotification);
            }
        })
    

        if(currentNotification && currentNotification !== <></>) {
            return <div style={{
                left: pos.x,
                top: pos.y,
                marginLeft: "-200px",
                marginTop: "-40px"
            }} className="notification-wrapper" ref={notificationWrapper}>
                {currentNotification}
            </div>;
        }
        return <></>;
}
export function openNotification(el: ReactNode, pos: {x: number, y: number} = {x: 0, y: 0}) {
    window.dispatchEvent(new CustomEvent("openNotification", { detail: { el, pos } }));
}

export function closeNotification() {
    window.dispatchEvent(new CustomEvent("openNotification", {detail: {el: <></>, pos: {x: 0, y: 0}}}));
}